import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7cd8073c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8073c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd8073c')) {
      api.createRecord('7cd8073c', component.options)
    } else {
      api.reload('7cd8073c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7cd8073c&scoped=true", function () {
      api.rerender('7cd8073c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsLabel/index.vue"
export default component.exports